import React, { FC, useCallback, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import DetailPageHeader from '../detail_page_header/DetailPageHeader';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { partsPerStockLocationsRestCrudThunksForSupplier } from '../../thunks/parts_per_stock_locations_thunks';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';

const PartsPerStockLocationDetailPage: FC<any> = ({
	companyConfig,
	ppsl,
	childRoutes,
	history,
	match,
	getPpsl,
	location,
}): React.ReactElement => {
	const tabs = useMemo(
		() => [
			{
				key: 'details',
				name: 'Overview',
			},
			{
				key: 'workOrders',
				name: 'Work Orders',
			},
		],
		[]
	);

	const stockLocationId = useMemo(() => nullSafeGet('stockLocation.id', ppsl), [ppsl]);

	const ppslId = useMemo(() => match.params.id, [match.params.id]);

	useEffect(() => ppslId && getPpsl(ppslId), [ppslId, getPpsl]);

	const handleTabChange = useCallback(
		(key) => {
			const ppslId = match.params.id;
			history.push(`/supplier/parts/partsPerStockLocation/detail/${ppslId}/${key}`);
		},
		[history, match.params.id]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	return (
		<DetailPageHeader
			exactPath={'/supplier/parts/partsPerStockLocation/detail/:id'}
			redirectPath={`/supplier/parts/partsPerStockLocation/detail/${ppslId}/details`}
			backLinkText={'Back to Stock Location'}
			backLinkTo={`/supplier/stockLocations/detail/${stockLocationId}/parts`}
			title={nullSafeGetOrElse('part.name', ppsl, '')}
			subtitle={
				<div className="flex flex-col">
					<div>{`Part #${nullSafeGetOrElse('part.partNumber', ppsl, '--')}`}</div>
					<div>{`@ ${nullSafeGetOrElse('stockLocation.name', ppsl, '')}`}</div>
				</div>
			}
			actions={[
				<Link key={1} to={`/supplier/parts/partsPerStockLocation/edit/${ppslId}`}>
					<Button ghost={true}>Edit</Button>
				</Link>,
				<Link
					className="ml-4"
					key={1}
					to={getLinkWIthBackLinkParams(
						location,
						'Back to Parts per Stock Location',
						`/supplier/parts/detail/${nullSafeGet('partId', ppsl)}/details`
					)}
				>
					<Button ghost={true}>View Part</Button>
				</Link>,
			]}
			tabs={tabs}
			backgroundColor={nullSafeGet('detail.config.theme.navblock', companyConfig)}
			handleTabChange={handleTabChange}
			checkTabActive={checkTabActive}
			childRoutes={childRoutes}
		/>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config,
	fetching: state.parts_per_stock_locations.fetching,
	ppsl: state.parts_per_stock_locations.detail,
});

const mapDispatchToProps = (dispatch) => ({
	getPpsl: (id) => dispatch(partsPerStockLocationsRestCrudThunksForSupplier.readOne(id)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(PartsPerStockLocationDetailPage)
);
